import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'
import { StoreFulfillmentCapabilitiesStore } from './capabilities-store-level'
import { StoreFulfillmentCapabilitiesRGD } from './capabilities-rgd-level'

export const StoreFulfillmentCapabilities = () => {
    const { currentLocation } = useEssentials()
    if (isStore(currentLocation)) {
        return <StoreFulfillmentCapabilitiesStore />
    } else {
        return <StoreFulfillmentCapabilitiesRGD />
    }
}
